import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useToast } from "../../../contexts/ToastContext";
import { useUser } from "../../../contexts/UserContext/UserContext";
import i18n from "../../../config/i18_init";
import SellInsurance from "./sellInsurance/SellInsurance";

/**
 * "Buy Insurance Directly" (`/sell-insurance`): standalone policy sales, separate from the
 * insurance products setup. Also receives the redirect back from the payment provider.
 */
const BuyInsurancePage = () => {
    const toast = useToast();
    const history = useHistory();
    const location = useLocation();
    const { myCompanyData } = useUser();
    const handledPaymentReturnRef = useRef(null);
    const [salesRefreshKey, setSalesRefreshKey] = useState(0);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const payment = params.get("payment");

        if (!payment || !myCompanyData) {
            return;
        }

        const saleId = params.get("saleId");
        const process = params.get("process");
        const returnKey = `${payment}:${saleId ?? ""}:${process ?? ""}:${location.search}`;

        if (handledPaymentReturnRef.current === returnKey) {
            return;
        }

        handledPaymentReturnRef.current = returnKey;

        const handlePaymentReturn = async () => {
            await i18n.loadNamespaces("sellInsurance");

            if (payment === "success") {
                const isExtension = process === "insuranceSaleExtension";
                toast.success({
                    message: i18n.t("sellInsurance:pay.stripeReturnSuccess"),
                    description: saleId
                        ? isExtension
                            ? i18n.t("sellInsurance:extend.paymentSuccessDescription", { id: saleId })
                            : i18n.t("sellInsurance:pay.stripeReturnSuccessDescription", { id: saleId })
                        : undefined,
                });
                setSalesRefreshKey((key) => key + 1);
            } else if (payment === "cancel") {
                toast.warning({
                    message: i18n.t("sellInsurance:pay.stripeReturnCancel"),
                    description: saleId
                        ? i18n.t("sellInsurance:pay.stripeReturnCancelDescription", { id: saleId })
                        : undefined,
                });
            }

            history.replace({ pathname: "/sell-insurance" });
        };

        handlePaymentReturn();
    }, [location.search, myCompanyData, history, toast]);

    return <SellInsurance refreshKey={salesRefreshKey} />;
};

export default BuyInsurancePage;
